import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TransactionTypeChangeModalUI from './TransactionTypeChangeModalUI.js'

class TransactionTypeChangeModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      type: '',
      typeError: null,
    }
  }

  render() {
    return (
      <TransactionTypeChangeModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        type={this.state.type}
        onTypeChange={(event) => { this.setState({ type: event.target.value }) }}
        typeError={this.state.typeError}
        setTypeError={(error) => { this.setState({ typeError: error }) }}
        creditTransactionTypeList={this.state.creditTransactionTypeList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTransactionTypes(context)
    Modal.setAppElement('body')
  }

  getTransactionTypes(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/transactionTypes`,
      cacheKey: CacheKeys.TransactionTypes(),
      callback: this.getTransactionTypesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTransactionTypesCallback = (response) => {
    let creditTransactionTypeList = response.creditTransactionTypeList.map((type) => {
      return { key: type.transactionTypeCode, value: type.transactionType }
    })
    this.setState({ creditTransactionTypeList: creditTransactionTypeList })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/virtualAccounts/${this.props.bankAccountNumber}/transactions/${this.props.selectedTransactionId}/types`,
      this.onSubmitCallback, {
      type: this.state.type,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(TransactionTypeChangeModalSF)
